import React, { useState, useEffect } from 'react';
import { Table, Button, Modal, Form, Input, message, Popconfirm } from 'antd';
import { store } from '../../../app/store';
import { ServicesConfig } from "../../../service/servicesConfig";

const RoleManager = () => {
  const [roles, setRoles] = useState([]);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [editingRole, setEditingRole] = useState(null);
  const [form] = Form.useForm();

  const baseURL = ServicesConfig.getBaseUrlV2()  + "/admin/role"; // Base URL para SGVMAP_ROLEController

  const getAuthorization = () => {
    const state = store.getState();
    return state.user.logged ? "Bearer " + state.user.token : ""
  }



  // Obtener la lista de roles
  const fetchRoles = async () => {
    try {
      const response = await fetch(`${baseURL}/list`, {
        headers: {
          'Authorization': getAuthorization()
        }
      }); // Asume que hay un endpoint para obtener todos los roles
      if (!response.ok) throw new Error("Error al obtener los roles");
      const data = await response.json();
      setRoles(data.map(role => ({ ...role, idRol: role.idRol }))); // Asegurarse de incluir idRol en los datos
    } catch (error) {
      message.error("Error al obtener la lista de roles");
      console.error(error);
    }
  };

  // Crear o actualizar un rol
  const handleSaveRole = async (values) => {
    const method = editingRole ? "PUT" : "POST";
    const url = editingRole ? `${baseURL}/update/${editingRole.idRol}` : `${baseURL}/create`;

    try {
      const response = await fetch(url, {
        method: method,
        headers: { "Content-Type": "application/json", 'Authorization': getAuthorization()},
        body: JSON.stringify(values),
      });
      if (!response.ok) throw new Error("Error al guardar el rol");

      message.success(editingRole ? "Rol actualizado correctamente" : "Rol creado correctamente");
      fetchRoles();
      setIsModalOpen(false);
      setEditingRole(null);
      form.resetFields();
    } catch (error) {
      message.error("Error al guardar el rol");
      console.error(error);
    }
  };

  // Eliminar un rol
  const handleDeleteRole = async (idRol) => {
    try {
      const response = await fetch(`${baseURL}/delete/${idRol}`, {
        method: "DELETE", headers: {
          'Authorization': getAuthorization()
        }
      });
      if (!response.ok) throw new Error("Error al eliminar el rol");

      message.success("Rol eliminado correctamente");
      fetchRoles();
    } catch (error) {
      message.error("Error al eliminar el rol");
      console.error(error);
    }
  };

  // Abrir modal para edición
  const handleEdit = (role) => {
    setEditingRole(role);
    form.setFieldsValue(role);
    setIsModalOpen(true);
  };

  // Abrir modal para crear
  const handleCreate = () => {
    setEditingRole(null);
    form.resetFields();
    setIsModalOpen(true);
  };

  useEffect(() => {
    fetchRoles();
  }, []);

  const columns = [
    {
      title: "ID",
      dataIndex: "idRol",
      key: "idRol",
    },
    {
      title: "Nombre",
      dataIndex: "name",
      key: "name",
    },
    {
      title: "Acciones",
      key: "actions",
      render: (text, record) => (
        <>
          <Button type="link" onClick={() => handleEdit(record)}>
            Editar
          </Button>
          <Popconfirm
            title="¿Estás seguro de eliminar este rol?"
            onConfirm={() => handleDeleteRole(record.idRol)}
            okText="Sí"
            cancelText="No"
          >
            <Button type="link" danger>
              Eliminar
            </Button>
          </Popconfirm>
        </>
      ),
    },
  ];

  return (
    <div>
      <h1>Gestión de Roles</h1>
      <Button type="primary" onClick={handleCreate} style={{ marginBottom: 16 }}>
        Crear Rol
      </Button>
      <Table columns={columns} dataSource={roles} rowKey="idRol" />

      <Modal
        title={editingRole ? "Editar Rol" : "Crear Rol"}
        open={isModalOpen}
        onCancel={() => setIsModalOpen(false)}
        onOk={() => form.submit()}
      >
        <Form
          form={form}
          layout="vertical"
          onFinish={handleSaveRole}
          initialValues={{ name: "" }}
        >
          <Form.Item
            name="idRol"
            label="ID del Rol"
            rules={[{ required: true, message: "Por favor, ingrese un ID" }]}
          >
            <Input placeholder="ID del Rol" disabled={!!editingRole} />
          </Form.Item>
          <Form.Item
            name="name"
            label="Nombre del Rol"
            rules={[{ required: true, message: "Por favor, ingrese un nombre" }]}
          >
            <Input placeholder="Nombre del Rol" />
          </Form.Item>
        </Form>
      </Modal>
    </div>
  );
};

export default RoleManager;
